const headerSearch = $('.js-headerSearch');
const headerSearchInput = $('.js-headerSearchInput');
const searchSuggest = $('.js-searchSuggest');
const suggestAction = '/ajax/search_suggest/index.php';

$(document).on('click', '.js-openHeaderSearch', function(e) {
	headerSearch.addClass('is_active');
	headerSearchInput.focus();
});

$(document).on('click', '.js-headerSearchClose', function(e) {
	headerSearch.removeClass('is_active');
	headerSearchInput.val('');
	closeSearchSuggest();
});

$(document).on('click', '.js-headerSearchClear', (e) => {
	$('.js-headerSearchInput').val('');
	closeSearchSuggest();
});


$(document).on('change input', '.js-headerSearchInput', (e) => {
	const current = $(e.currentTarget);

	if (current.val().length >= 1) {
		searchSuggest.addClass('is_visible');
	} else {
		closeSearchSuggest();
	}

	if (current.val().length >= 2) {
		$.ajax({
			url: suggestAction,
			data: {q: current.val()},
			method: 'POST',
			success: function(response) {
				$(searchSuggest).find('.container').html($(response).find('.js-searchSuggest-container').html());
			}
		});
	}
});

$(document).on('click', '.js-searchSuggestOpen', (e) => {
	const ww = $(window).width();

	if (ww >= 1200) {
		headerSearch.addClass('is_active');
		searchSuggest.addClass('is_visible');

		setTimeout(() => {
			headerSearchInput.focus();
		}, 300);
	} else {
		$('.js-openMenu').trigger('click');
		searchSuggest.addClass('is_visible');

		setTimeout(() => {
			$('.menu .js-headerSearchInput').focus();
		}, 300);
	}
});

function bxPanelSuggestPosition() {
	const ww = $(window).width();
	const isHeaderSticky = $('body').hasClass('is_header_sticky');

	if ($('#bx-panel').length > 0 && ww >= 1200 && !isHeaderSticky) {
		const offset = $('#bx-panel').height() + $('.header-top').height();
		searchSuggest.css('top', offset);
	} else {
		searchSuggest.css('top', '');
	}
}

$(window).on('load resize scroll', bxPanelSuggestPosition);

bxPanelSuggestPosition();

export function closeSearchSuggest() {
	searchSuggest.removeClass('is_visible');
}
